// extracted by mini-css-extract-plugin
export default {"filter":"styles_filter__D1fm5","text":"styles_text__Qsx52","afterFilter":"styles_afterFilter__SIN47","filterRange":"styles_filterRange__vRYnq","close":"styles_close__j+r88"};